import type { AddNumberModalUICopy } from './types';

export const ADD_NUMBER_MODAL: AddNumberModalUICopy = {
  telephonyConfig: {
    title: {
      default: 'Select your telephony configuration',
      fromCreateAssistant: 'Your agent has been created',
    },
    description: `Select your preferred method to interact with your agent. You can test it via chat, even if you don't select anything.`,
    options: {
      buy: {
        title: 'Buy phone number',
        description: "You'll be able to buy either a UK or a US phone number",
      },
      twilio: {
        title: 'Connect existing number',
        description:
          'Connect your Twilio account to your agent on Agent studio',
      },
    },
    button: {
      cancel: {
        default: 'Cancel',
        fromCreateAssistant: "I'll do it later",
      },
      confirm: 'Next',
    },
  },
  connectExistingNumber: {
    title: 'Connect existing number',
    description: supportEmail => (
      <>
        We are working on supporting more service providers. Let us know which
        platform you&apos;d like us to support by email us at {supportEmail}.
      </>
    ),
    button: {
      cancel: 'Cancel',
      back: 'Back',
      done: 'Done',
    },
  },
  buyPhoneNumber: {
    title: {
      default: 'Add number',
      fromCreateAssistant: 'Choose a number',
    },
    button: {
      cancel: 'Cancel',
      back: 'Back',
      done: 'Add number',
    },
  },
  card: {
    phoneNumber: {
      title: country => `${country} phone number`,
      description: fakeNumber => (
        <>You&apos;ll be able to call your agent on a {fakeNumber} number.</>
      ),
    },
    twilio: {
      title: {
        default: 'Twilio phone number',
        connect: 'Connect Twilio phone number',
      },
      description: {
        nonSettingsPage:
          'You can manage this connection on the setting page of the agent. ',
        instruction: renderLink => (
          <>
            Add the generated SIP address to your Twilio account.{' '}
            {renderLink('Read how to do it')}.
          </>
        ),
      },
      loading: 'Loading...',
    },
  },
  clipboard: {
    sipAddressCopied: environment =>
      `${environment} SIP address is copied to clipboard`,
  },
};
